import { render, staticRenderFns } from "./PhoneInTalk.vue?vue&type=template&id=8cb8ae7c"
import script from "./PhoneInTalk.vue?vue&type=script&lang=js"
export * from "./PhoneInTalk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports